import { gql } from '@apollo/client'

const commentFragment = gql`
  fragment CommentMutation_document on Document {
    id
    text
    docId
    date
    publisher {
      url
      fullname
      thumborImage {
        current: thumbUrl(size: "50x50")
      }
      hasProBadge
      isViewer
    }
    viewerLiked
    votesAmount
  }
`

export const EditTextComment = gql`
  mutation EditTextComment($input: EditTextDocumentInput!) {
    editTextDocument(input: $input) {
      document {
        text
        id
      }
    }
  }
`

export const AddReply = gql`
  mutation AddReplyDocumentComment($input: AddReplyDocumentCommentInput!) {
    addReplyDocumentComment(input: $input) {
      commentParent {
        id
        docId
      }
      reply {
        ...CommentMutation_document
      }
      document {
        id
        numComments
      }
    }
  }
  ${commentFragment}
`
export const AddComment = gql`
  mutation addComment($input: AddCommentDocumentInput!) {
    addComment(input: $input) {
      comment {
        ...CommentMutation_document
      }
      document {
        id
        numComments
      }
    }
  }
  ${commentFragment}
`
